(function () {
  const root = document.getElementById("sb-bundle-builder");
  if (!root) {
    console.error("Bundle Builder: #sb-bundle-builder not found. The script ran before the section markup existed.");
    return;
  }
  console.log("Bundle Builder: script loaded, initialising.");

  // ---------------------------------------------------------------------
  // CONTAINER MAP — fixed unit value per packaging type.
  // ---------------------------------------------------------------------
  // Densities (kg per liter; water = 1.00). Oil floats, balsamic sinks —
  // the grape-must sugars make balsamic ~7% heavier than water, olive
  // oil ~8% lighter. A 500ml balsamic weighs ~77g more than the same
  // bottle of oil, so shipped-weight estimates account for it.
  const DENSITY = { oil: 0.916, balsamic: 1.07 };
  const GLASS_G = { A: 90, J: 130, E: 265, F: 380 }; // 60ml Marasca / 120ml / 250ml / 500ml Dorica tare
  const VOL_ML = { A: 60, J: 120, E: 250, F: 500 };

  const CONTAINER_TYPES = {
    A: { label: "2oz Marasca", units: 1 }, // 125mm x 35mm sq — weight from density
    B: { label: "4oz Jar", units: 1.5, weightLb: 0.56 },
    C: { label: "9oz Jar", units: 2.5, weightLb: 1.0 },
    D: { label: "11.25oz Jar", units: 3, weightLb: 1.21 },
    E: { label: "250ml Dorica", units: 2.5 }, // weight from density
    F: { label: "500ml Dorica", units: 4 },   // weight from density
    G: { label: "Stout Sauce Bottle", units: 2.5, weightLb: 1.3 },
    H: { label: "5oz Olive Jar", units: 2, weightLb: 0.67 },
    I: { label: "400ml Drizzle Squeeze", units: 3.5, weightLb: 0.94 },
    J: { label: "120ml Bottle", units: 1.5 }, // limited editions — weight from density
  };

  // Filled weight of a container in lb. Dorica bottles: glass tare +
  // volume x liquid density (1L water = 1kg).
  function weightLbForContainer(letter, productType) {
    const c = CONTAINER_TYPES[letter];
    if (!c) return 0.35;
    if (c.weightLb != null) return c.weightLb;
    const density = productType === "Vinegars" || /vinegar|balsamic/i.test(productType || "")
      ? DENSITY.balsamic : DENSITY.oil;
    return (GLASS_G[letter] + VOL_ML[letter] * density) / 453.6;
  }

  // ---------------------------------------------------------------------
  // CATEGORY SOURCES — the builder reads your existing Shopify
  // collections directly. No product-type or tag data entry needed:
  // the collections below are already maintained on the store.
  //
  //   handle   the collection's URL handle on sutterbuttesoliveoil.com
  //   label    what the customer sees in the category filter row
  //   rule     how variants in this collection are sized
  //   include  optional whitelist of product handles (top-N categories)
  //   exclude  optional blacklist (gift tins, personalized bottles, etc.)
  // ---------------------------------------------------------------------
  const CATEGORY_SOURCES = [
    {
      handle: "extra-virgin-olive-oil",
      label: "Extra Virgin Olive Oils",
      rule: { sizeVariant: true },
      exclude: [
        "extra-virgin-olive-oil-tin",                    // Signature Gift Tin
        "personalized-label-750-ml-extra-virgin-olive-oil",
        "holiday-label-750-ml-extra-virgin-olive-oil",
      ],
    },
    {
      handle: "flavored-olive-oils",
      label: "Infused Olive Oils",
      rule: { sizeVariant: true },
      include: [ // top 4 best sellers
        "meyer-lemon-olive-oil",
        "fresh-harvest-garlic-olive-oil",
        "tuscan-herb-olive-oil",
        "garlic-herb-olive-oil",
      ],
    },
    {
      handle: "balsamic-vinegars",
      label: "Balsamic Vinegars",
      rule: { sizeVariant: true, balsamic: true },
      include: [ // top 4 best sellers
        "traditional-aged-balsamic-vinegar",
        "california-fig-balsamic-vinegar",
        "dark-cherry-balsamic-vinegar",
        "chocolate_balsamic",
      ],
    },
    { handle: "dipping-oils", label: "Dipping Oils", rule: { sizeVariant: true } },
    { handle: "olives",       label: "Olives",       rule: { fixed: "H" } },
    { handle: "sea-salts",    label: "Sea Salts",    rule: { saltSizes: true } },
    { handle: "spices-rubs",  label: "Spices & Rubs", rule: { fixed: "B" } },
    {
      handle: "tapenades-spreads",
      label: "Tapenades",
      rule: { jarSizes: true },
      include: [
        "sun-dried-tomato-and-olive-tapenade",
        "artichoke-pesto",
        "farmhouse-olive-tapenade",
        "kalamata-and-caper-tapenade",
      ],
    },
    {
      handle: "gourmet-mustards",
      label: "Mustards",
      rule: { jarSizes: true },
      include: [
        "lemon-dill",
        "amber-beer-mustard",
        "jalapeno-whiskey-mustard",
        "chardonnay-mustard",
      ],
    },
    {
      handle: "jams",
      label: "Jams",
      rule: { jarSizes: true },
      include: [ // top 4 per SIZE — 4oz tier then 9oz tier
        "strawberryjam", "apricot-jalapeno-jam",
        "spiced-peach-and-bourbon", "meyer-lemon-ginger",
        "raspberry-blackberry-with-cardamom", "pinwapplemango",
        "fig-jam-2", "caramelized-onion-and-balsamic-spread",
      ],
    },
    {
      handle: "sauces-and-soups",
      label: "Sauces",
      rule: { fixed: "G" },
      include: [
        "butter-chicken",
        "french-onion-soup",
        "tuscan-sun-dried-tomato-sauce",
        "creamy-vodka-pasta-sauce",
      ],
    },
  ];

  // Products never eligible for a build-your-box, whatever collection they
  // appear in — pre-composed sets would nest a bundle inside a bundle.
  const GLOBAL_EXCLUDE_PATTERNS = [
    /gift-?set/i, /gift-?box/i, /gift-?tin/i, /-tin$/i, /bundle/i,
    /case-?pack/i, /sampler/i, /mystery/i, /advent/i, /dinner-?box/i,
    /personalized/i, /custom-?label/i, /wedding/i, /baking-?kit/i,
  ];
  function isGloballyExcluded(handle, title) {
    const hay = handle + " " + (title || "");
    return GLOBAL_EXCLUDE_PATTERNS.some((re) => re.test(hay));
  }

  function containerForVariant(rule, variantTitle) {
    if (!rule) return "A";
    if (rule.fixed) return rule.fixed;
    const t = (variantTitle || "").toLowerCase();
    if (rule.sizeVariant) {
      if (t.includes("400") || t.includes("drizzle") || t.includes("squeeze")) return "I";
      if (t.includes("750")) return "F"; // treated as a large bottle
      if (t.includes("500")) return "F";
      if (t.includes("250")) return "E";
      if (t.includes("120")) return "J"; // limited-edition sample bottle
      if (t.includes("2oz") || t.includes("2 oz") || t.includes("60ml") ||
          t.includes("60 ml") || t.includes("marasca") || t.includes("mini")) return "A";
      return "E"; // default to the smaller Dorica
    }
    if (rule.jarSizes) {
      if (t.includes("11")) return "D";
      if (t.includes("9")) return "C";
      if (t.includes("4")) return "B";
      return "C";
    }
    if (rule.saltSizes) return t.includes("large") ? "C" : "B";
    return "A";
  }
  function unitsForContainer(letter) {
    return CONTAINER_TYPES[letter] ? CONTAINER_TYPES[letter].units : 1;
  }

  // -------------------------------------------------------------------
  // BOXES — read from the section settings in the theme customizer.
  // Tare = corrugate + dividers + void fill, used for shipped-weight
  // estimates only; it does not count against box capacity.
  // -------------------------------------------------------------------
  const BOX_TARE_LB = { box1: 1.5, box2: 2, box3: 3 };

  const BOXES = [1, 2, 3].map((n) => ({
    id: "box" + n,
    name: root.dataset["box" + n + "Name"] || "Box " + n,
    tagline: root.dataset["box" + n + "Tagline"] || "",
    capacity: parseFloat(root.dataset["box" + n + "Capacity"]) || 0,
    priceCeiling: parseFloat(root.dataset["box" + n + "Ceiling"]) || null,
    tareLb: BOX_TARE_LB["box" + n] || 2,
  }));

  // Discount curve — keep in sync with whatever your volume-discount app
  // applies automatically at checkout.
  const DISCOUNT_TIERS = [
    { min: 6, pct: 0.15 },
    { min: 4, pct: 0.10 },
    { min: 2, pct: 0.05 },
    { min: 0, pct: 0 },
  ];
  function getDiscount(n) {
    return DISCOUNT_TIERS.find((t) => n >= t.min).pct;
  }

  let CATALOG = [];
  let CATEGORIES = ["All"];
  let state = { boxId: null, category: "All", cart: {}, selected: {}, pendingSwitch: null, notice: null };

  // -------------------------------------------------------------------
  // SESSION MEMORY — an abandoned half-built box survives page leaves
  // and comes back for 7 days. Cleared once the box is added to cart.
  // -------------------------------------------------------------------
  const STORAGE_KEY = "sb-bundle-builder-v1";
  const STORAGE_TTL_MS = 7 * 24 * 60 * 60 * 1000;
  function saveState() {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ boxId: state.boxId, cart: state.cart, ts: Date.now() }));
    } catch (e) { /* private mode etc. — persistence is best-effort */ }
  }
  function restoreState() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return;
      const saved = JSON.parse(raw);
      if (!saved.ts || Date.now() - saved.ts > STORAGE_TTL_MS) { localStorage.removeItem(STORAGE_KEY); return; }
      // Only restore variant ids that still exist in the live catalog.
      const cart = {};
      Object.entries(saved.cart || {}).forEach(([id, qty]) => {
        if (CATALOG.find((p) => String(p.variantId) === id)) cart[id] = qty;
      });
      if (saved.boxId && BOXES.find((b) => b.id === saved.boxId)) {
        state.boxId = saved.boxId;
        state.cart = cart;
      }
    } catch (e) { /* corrupt state — ignore */ }
  }
  function clearSavedState() {
    try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
  }

  async function loadCatalog() {
    // Paint the box cards right away so the UI never depends on the
    // network. Products fill in underneath once the fetches return.
    renderAll();
    // Fetch every category collection in parallel. Each product is sized
    // by the rule attached to the collection it came from.
    const results = await Promise.all(
      CATEGORY_SOURCES.map(async (src) => {
        try {
          const res = await fetch(`/collections/${src.handle}/products.json?limit=250`);
          if (!res.ok) throw new Error(res.status + " on " + src.handle);
          const data = await res.json();
          return { src, products: data.products || [] };
        } catch (err) {
          console.warn("Bundle Builder: could not load collection", src.handle, err);
          return { src, products: [] };
        }
      })
    );

    CATALOG = [];
    const seen = new Set(); // a product in two collections is listed once
    results.forEach(({ src, products }) => {
      products.forEach((p) => {
        if (seen.has(p.handle)) return;
        if (src.include && !src.include.includes(p.handle)) return;
        if (src.exclude && src.exclude.includes(p.handle)) return;
        if (isGloballyExcluded(p.handle, p.title)) return;
        seen.add(p.handle);
        p.variants.forEach((v) => {
          const letter = containerForVariant(src.rule, v.title);
          CATALOG.push({
            productKey: p.handle,
            variantId: v.id,
            name: p.title,
            variant: v.title,
            category: src.label,
            price: parseFloat(v.price),
            units: unitsForContainer(letter),
            weightLb: weightLbForContainer(letter, src.rule.balsamic ? "Vinegars" : "Oils"),
            available: v.available,
          });
        });
      });
    });

    CATALOG = CATALOG.filter((p) => p.available);
    // Category order follows CATEGORY_SOURCES, not discovery order.
    const present = CATEGORY_SOURCES.map((s) => s.label)
      .filter((label) => CATALOG.some((p) => p.category === label));
    CATEGORIES = ["All", ...present];

    if (CATALOG.length === 0) {
      console.error("Bundle Builder: no products loaded. Check collection handles in CATEGORY_SOURCES.");
      const grid = document.getElementById("sb-bb-grid");
      if (grid) grid.innerHTML = '<p style="font-family:Arial,sans-serif;font-size:13px;color:#9A9081">Products could not be loaded. Please refresh, or contact us if this continues.</p>';
    }
    restoreState();
    renderAll();
  }

  function currentBox() {
    return BOXES.find((b) => b.id === state.boxId);
  }
  function lines() {
    return Object.entries(state.cart)
      .filter(([, q]) => q > 0)
      .map(([id, qty]) => ({ ...CATALOG.find((p) => String(p.variantId) === id), qty }));
  }
  function totals() {
    const ls = lines();
    const totalUnits = ls.reduce((s, l) => s + l.units * l.qty, 0);
    const rawSubtotal = ls.reduce((s, l) => s + l.price * l.qty, 0);
    const totalWeightLb = ls.reduce((s, l) => s + (l.weightLb || 0) * l.qty, 0);
    const itemCount = ls.reduce((s, l) => s + l.qty, 0);
    const discountPct = getDiscount(itemCount);
    return { totalUnits, rawSubtotal, totalWeightLb, itemCount, discountPct, finalPrice: rawSubtotal * (1 - discountPct) };
  }
  function canAdd(p) {
    const box = currentBox();
    if (!box) return false;
    const t = totals();
    if (p.units > box.capacity - t.totalUnits + 1e-9) return false;
    if (box.priceCeiling && p.price > box.priceCeiling - t.rawSubtotal + 1e-9) return false;
    return true;
  }

  // Greedily keep items in order until a cap of the target box would be
  // exceeded — used when carrying items across a tier switch (upgrades
  // always fit; downgrades may trim).
  function fitsInBox(box, cartObj) {
    let units = 0, value = 0;
    const kept = {}; let trimmed = 0;
    for (const [id, qty] of Object.entries(cartObj)) {
      const p = CATALOG.find((x) => String(x.variantId) === id);
      if (!p) continue;
      for (let i = 0; i < qty; i++) {
        const overUnits = units + p.units > box.capacity + 1e-9;
        const overPrice = box.priceCeiling && value + p.price > box.priceCeiling + 1e-9;
        if (overUnits || overPrice) { trimmed++; continue; }
        units += p.units; value += p.price;
        kept[id] = (kept[id] || 0) + 1;
      }
    }
    return { kept, trimmed };
  }

  function switchBox(id) {
    const hasItems = Object.values(state.cart).some((q) => q > 0);
    if (state.boxId && state.boxId !== id && hasItems) {
      state.pendingSwitch = id; // inline prompt rendered in summary
      renderAll();
      return;
    }
    state.boxId = id;
    state.cart = {};
    state.pendingSwitch = null;
    state.notice = null;
    saveState();
    renderAll();
  }

  function resolveSwitch(keepItems) {
    const targetId = state.pendingSwitch;
    state.pendingSwitch = null;
    if (!targetId) return;
    const target = BOXES.find((b) => b.id === targetId);
    if (keepItems === null) { renderAll(); return; } // cancelled
    if (keepItems) {
      const { kept, trimmed } = fitsInBox(target, state.cart);
      state.boxId = targetId;
      state.cart = kept;
      state.notice = trimmed > 0 ? trimmed + " item(s) didn't fit " + target.name + "'s limits and were removed." : null;
    } else {
      state.boxId = targetId;
      state.cart = {};
      state.notice = null;
    }
    saveState();
    renderAll();
  }

  function renderBoxes() {
    const el = document.getElementById("sb-bb-boxes");
    el.innerHTML = "";
    BOXES.forEach((b) => {
      const active = state.boxId === b.id;
      const card = document.createElement("button");
      card.className = "sb-box-card" + (active ? " active" : "");
      card.innerHTML = `
        <div class="sb-tag">${b.tagline || ""}</div>
        <h3>${b.name}</h3>
        <div class="sb-stats">
          <div>Capacity: ${b.capacity} units</div>
          <div>${b.priceCeiling ? `Up to $${b.priceCeiling} retail value` : "No price ceiling"}</div>
        </div>`;
      card.onclick = () => switchBox(b.id);
      el.appendChild(card);
    });
  }

  function renderCats() {
    const el = document.getElementById("sb-bb-cats");
    el.innerHTML = "";
    CATEGORIES.forEach((c) => {
      const btn = document.createElement("button");
      btn.textContent = c;
      if (state.category === c) btn.classList.add("active");
      btn.onclick = () => {
        state.category = c;
        renderAll();
      };
      el.appendChild(btn);
    });
  }

  // Variants of one product are grouped into a single card with a size
  // selector, mirroring how the product pages work on the storefront.
  function groupedProducts() {
    const items = state.category === "All"
      ? CATALOG
      : CATALOG.filter((p) => p.category === state.category);
    const groups = new Map();
    items.forEach((v) => {
      const key = v.productKey || v.name;
      if (!groups.has(key)) {
        groups.set(key, { key, name: v.name, category: v.category, variants: [] });
      }
      groups.get(key).variants.push(v);
    });
    // Smallest size first so the cheapest entry point leads.
    groups.forEach((g) => g.variants.sort((a, b) => a.units - b.units || a.price - b.price));
    return Array.from(groups.values());
  }

  function selectedVariantFor(group) {
    const chosen = state.selected[group.key];
    return group.variants.find((v) => String(v.variantId) === String(chosen)) || group.variants[0];
  }

  function renderGrid() {
    const el = document.getElementById("sb-bb-grid");
    el.innerHTML = "";
    groupedProducts().forEach((g) => {
      const sel = selectedVariantFor(g);
      const qty = state.cart[sel.variantId] || 0;
      const addable = canAdd(sel);
      // Total of this product already in the box, across all its sizes.
      const inBox = g.variants.reduce((n, v) => n + (state.cart[v.variantId] || 0), 0);

      const sizeRow = g.variants.length > 1
        ? `<div class="sb-sizes">${g.variants.map((v) => {
            const vq = state.cart[v.variantId] || 0;
            const active = String(v.variantId) === String(sel.variantId);
            const fits = canAdd(v) || vq > 0;
            return `<button type="button" class="sb-size${active ? " active" : ""}${fits ? "" : " full"}" data-variant="${v.variantId}" data-group="${g.key}">${v.variant}${vq > 0 ? `<span class="sb-size-qty">${vq}</span>` : ""}</button>`;
          }).join("")}</div>`
        : `<div class="sb-variant">${g.variants[0].variant}</div>`;

      const card = document.createElement("div");
      card.className = "sb-card";
      card.innerHTML = `
        <div>
          <div class="sb-cat">${g.category}</div>
          <h4>${g.name}</h4>
          ${sizeRow}
        </div>
        <div class="sb-row">
          <div>
            <div class="sb-price">$${sel.price.toFixed(2)}</div>
            <div class="sb-units">${sel.units.toFixed(1)} unit${sel.units !== 1 ? "s" : ""}${inBox > 0 ? ` &middot; ${inBox} in box` : ""}</div>
          </div>
          <div class="sb-ctrl">
            ${qty > 0 ? `<button type="button" class="sb-minus">&minus;</button><span>${qty}</span>` : ""}
            <button type="button" class="sb-add" ${addable ? "" : "disabled"}>+</button>
          </div>
        </div>`;

      card.querySelectorAll(".sb-size").forEach((btn) => {
        btn.onclick = () => {
          state.selected[btn.dataset.group] = btn.dataset.variant;
          renderAll();
        };
      });
      if (qty > 0) {
        card.querySelector(".sb-minus").onclick = () => {
          state.cart[sel.variantId] = Math.max(0, qty - 1);
          saveState();
          renderAll();
        };
      }
      card.querySelector(".sb-add").onclick = () => {
        if (!canAdd(sel)) return;
        state.cart[sel.variantId] = (state.cart[sel.variantId] || 0) + 1;
        saveState();
        renderAll();
      };
      el.appendChild(card);
    });
  }

  // Adding via a real form POST rather than fetch(). A fetch to
  // /cart/add.js lets the theme's cart-drawer script intercept the add
  // and pop the drawer open — and the drawer renders raw line prices
  // without the volume discount, so the shopper sees full price at the
  // exact moment they commit. A form POST is a normal browser
  // navigation: no JS can intercept it, and `return_to` lands the
  // shopper on /cart, where the discount is displayed correctly.
  function addBoxToCart(box, ls) {
    const groupId = "bundle-" + Date.now();
    const form = document.createElement("form");
    form.method = "post";
    form.action = "/cart/add";
    form.style.display = "none";
    form.setAttribute("accept-charset", "UTF-8");

    function hidden(name, value) {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = name;
      input.value = value;
      form.appendChild(input);
    }

    hidden("form_type", "product");
    hidden("utf8", "\u2713");

    ls.forEach((l, i) => {
      hidden(`items[${i}][id]`, l.variantId);
      hidden(`items[${i}][quantity]`, l.qty);
      hidden(`items[${i}][properties][Box]`, box.name);
      hidden(`items[${i}][properties][_bundle_group]`, groupId);
    });

    // Land on the full cart page, never the drawer.
    hidden("return_to", "/cart");

    // The box is committed — don't restore it if they come back.
    clearSavedState();

    document.body.appendChild(form);
    form.submit();
  }

  function renderSummary() {
    const box = currentBox();
    const t = totals();
    const el = document.getElementById("sb-bb-summary");
    const ls = lines();
    // Box is complete when items are picked and nothing left in the
    // catalog fits under both remaining caps (price room + space).
    // Example: $70 used of a $72 ceiling and no item costs <= $2 —
    // the customer is done, don't leave them hunting for a filler item.
    const complete = ls.length > 0 && !CATALOG.some((p) => canAdd(p));
    const priceBar = box.priceCeiling
      ? `
      <div class="sb-barlabel"><span>Retail value used</span><span>$${t.rawSubtotal.toFixed(2)} / $${box.priceCeiling}</span></div>
      <div class="sb-bar sb-price-bar"><div style="width:${Math.min(100, (t.rawSubtotal / box.priceCeiling) * 100)}%"></div></div>`
      : "";
    const pendingBox = state.pendingSwitch ? BOXES.find((b) => b.id === state.pendingSwitch) : null;
    const switchPrompt = pendingBox ? `
      <div class="sb-switch-prompt">
        <div>Move your items to <b>${pendingBox.name}</b>?</div>
        <button class="sb-sw-keep">Keep my items</button>
        <button class="sb-sw-fresh">Start fresh</button>
        <button class="sb-sw-cancel">Cancel</button>
      </div>` : "";
    const noticeHtml = state.notice ? `<div class="sb-notice">${state.notice}</div>` : "";
    const otherBoxes = BOXES.filter((b) => b.id !== box.id);
    const switchLinks = `
      <div class="sb-switch-links">
        Switch box: ${otherBoxes.map((b) => `<button type="button" class="sb-sw-link" data-box="${b.id}">${(b.name || "").replace("The ", "")}</button>`).join(" ")}
      </div>`;
    el.innerHTML = `
      <h3>${box.name}</h3>
      ${switchPrompt}
      ${noticeHtml}
      <div class="sb-barlabel"><span>Space used</span><span>${t.totalUnits.toFixed(1)} / ${box.capacity} units</span></div>
      <div class="sb-bar"><div style="width:${Math.min(100, (t.totalUnits / box.capacity) * 100)}%"></div></div>
      <div class="sb-barlabel"><span>Est. shipped weight</span><span>${(t.totalWeightLb + box.tareLb).toFixed(1)} lb (incl. ${box.tareLb} lb box)</span></div>
      ${priceBar}
      ${complete ? '<div class="sb-complete">&#10003; Your box is full &mdash; nothing else fits. Ready to go!</div>' : ""}
      <div class="sb-lines">
        ${
          ls.length === 0
            ? '<div class="sb-empty">Nothing added yet.</div>'
            : ls.map((l) => `<div class="sb-line"><span>${l.qty}× ${l.name} <span class="sb-faint">(${l.variant})</span></span><span>$${(l.price * l.qty).toFixed(2)}</span></div>`).join("")
        }
      </div>
      <div class="sb-totals">
        <div class="sb-r"><span>Subtotal</span><span>$${t.rawSubtotal.toFixed(2)}</span></div>
        <div class="sb-r sb-disc"><span>Bundle discount (${(t.discountPct * 100).toFixed(0)}%)</span><span>-$${(t.rawSubtotal * t.discountPct).toFixed(2)}</span></div>
        <div class="sb-r sb-final"><span>Box total</span><span>$${t.finalPrice.toFixed(2)}</span></div>
      </div>
      <div class="sb-note">Final price reflects the volume discount your cart applies automatically at checkout.</div>
      <button class="sb-addcart" ${ls.length === 0 ? "disabled" : ""}>${complete ? "Complete box &mdash; add to cart" : "Add box to cart"}</button>
      ${switchLinks}
    `;
    el.querySelector(".sb-addcart").onclick = () => {
      if (ls.length === 0) return;
      addBoxToCart(box, ls);
    };
    el.querySelectorAll(".sb-sw-link").forEach((btn) => {
      btn.onclick = (e) => { e.preventDefault(); switchBox(btn.dataset.box); };
    });
    if (pendingBox) {
      el.querySelector(".sb-sw-keep").onclick = () => resolveSwitch(true);
      el.querySelector(".sb-sw-fresh").onclick = () => resolveSwitch(false);
      el.querySelector(".sb-sw-cancel").onclick = () => resolveSwitch(null);
    }
  }

  function renderAll() {
    renderBoxes();
    const main = document.getElementById("sb-bb-main");
    if (!state.boxId) {
      main.classList.add("sb-hidden");
      return;
    }
    main.classList.remove("sb-hidden");
    renderCats();
    renderGrid();
    renderSummary();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", loadCatalog);
  } else {
    loadCatalog();
  }
})();